import { LANDING_CONTACT_EMAIL } from '../constants/posLandingConst';

/**
 * The till sign-in's help line: who to ask when a sign-in will not go
 * through. The manager comes first because they hold the staff list and the
 * passwords; support is the address on the landing page.
 *
 * @returns {JSX.Element}
 */
function PosLoginSupportLine() {
  return (
    <>
      Trouble signing in? Ask your manager to check your access, or
      {' '}
      <a href={`mailto:${LANDING_CONTACT_EMAIL}`}>contact support</a>
      .
    </>
  );
}

export default PosLoginSupportLine;
